import { CheckCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const DefaultCompleted = ({ title }) => (
  <Box display="flex" flexDirection="column" height="100%">

    {/* Placeholder Body */}
    <Box
      flex={1}
      display="flex"
      flexDirection={"column"}
      alignItems="center"
      justifyContent="center"
      maxWidth={350}
      margin={"auto"}
      textAlign={"center"}
      gap={2}
    >
      <Box
        sx={{
          borderRadius: "100%",
          height: "72px",
          width: "72px",
          background: "#EEEEEE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CheckCircle
          fontSize="52px"
          sx={{ color: "green", fontSize: "52px" }}
        />
      </Box>
      <Typography variant="title1">Account is connected</Typography>
      <Typography variant="body2" color="text.secondary">
        Kindly <a href="mailto:support@adyogi.com">Contact Support</a> for any issue. 
        
      </Typography>
    </Box>
  </Box>
);

export default DefaultCompleted;